import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import { IResourceListScope, useApiClientContext } from '../../store/api-client-context';

interface Props {
	scopes: IResourceListScope[],
	setSelectedPermissions: (value: any) => void,
	resourceName: string,
	isEditMode: boolean,
}

export const CustomKeyPermissions: FC<Props> = (props) => {
	const { scopes, setSelectedPermissions, resourceName, isEditMode } = props;
	const [selectedLocalPermission, setSelectedLocalPermission] = useState<string>('');
	const { apiClientContextState: { apiClientKeysDetails }} = useApiClientContext();


	const newPermissions = [
		{
			name: 'none',
			displayName: 'None',
			id: ''
		},
		...scopes
	];

	useEffect(() => {
		if (!apiClientKeysDetails?.scopes.length) {
			setSelectedLocalPermission('none');
		} else {
			const res = scopes?.find(el => apiClientKeysDetails?.scopes.includes(el?.id));
			if (res) {
				setSelectedLocalPermission(res?.name);
				setSelectedPermissions(prev => ({ ...prev, [resourceName]: res?.id }));
			} else {
				setSelectedLocalPermission('none');
			}
		}
	}, []);

	const handleChangePermission = (id, name): void => {
		setSelectedPermissions(prev => ({ ...prev, [resourceName]: id }));
		setSelectedLocalPermission(name);
	};
	return (
		<div className="d-flex">
			<div className={clsx('d-flex align-items-center', isEditMode && 'permissions-container')}>
				{newPermissions?.map(({ id, name, displayName }) => (
					<div
						key={id}
						className={clsx(
							'p-2',
							selectedLocalPermission === name && 'text-danger fw-bolder',
							isEditMode ? 'cursor-pointer' : 'cursor-not-allowed'
						)}
						onClick={(): void => isEditMode && handleChangePermission(id, name)}
					>
						{displayName}
					</div>
				))}
			</div>
		</div>
	);
};
